import {TextField } from "@mui/material";


const ResetPassword: React.FC = () => {
 return (
      <div style={{ textAlign: 'center' }}>
        <div>
            <h2>Reset Password</h2>
            
            <div >
            <label  style={{ marginRight: "280px" ,fontWeight: 'bold' }}>New Password:</label>
                <br /> {/* Line break for next line */}
                <TextField
                    fullWidth
                    placeholder="Enter Password"
                    id="Password"
                    style={{ width: '350px' }}
                />
            </div>
            <div style={{ marginBottom: "10px" }} />
            <label style={{ marginRight: "280px",fontWeight: 'bold' }}>Confirm Password:</label>
            <br/>
       
            <TextField
         style={{ width: '350px' }}
                    type="password"
                    id="password"
                    placeholder="Enter Password"
            />
      <br/>
            <div style={{ marginBottom: "10px" }} />
            <div style={{ textAlign: 'center' }}>
              <button>Sign In</button>
</div>
        </div>
        </div>
    );
};
export default ResetPassword;